import { getUserDetails, isAdminUser } from "../services/authService";

/**
 * When true, CRM Hub nav/APIs stay platform-admin only.
 * Keep false so entitled agents get CRM (leads / offers / dockets).
 */
export const CRM_HUB_ADMIN_ONLY = false;

/**
 * CRM Hub for BASIC + PRO (+ AGENCY) when true.
 * Later PRO-only: set false (+ revert BASIC leads_system in DB).
 */
export const CRM_HUB_PHASE_INCLUDES_BASIC = true;

function normalizePackageTier(value) {
  const u = String(value || "").trim().toUpperCase();
  if (!u) return "";
  if (u === "STARTER" || u === "BASIC") return "BASIC";
  if (u === "PRO") return "PRO";
  if (u === "AGENCY") return "AGENCY";
  return "";
}

function resolveAgentPackageTier(effectivePackageCode) {
  if (effectivePackageCode != null && String(effectivePackageCode).trim()) {
    return normalizePackageTier(effectivePackageCode);
  }
  try {
    const u = getUserDetails?.() || {};
    return normalizePackageTier(
      u.package_code ?? u.packageCode ?? u.plan ?? u?.package?.code
    );
  } catch {
    return "";
  }
}

/**
 * CRM Hub gate.
 * Overrides: VITE_CRM_HUB_ENABLED / localStorage crm_hub_enabled = 0|1
 */
export function isCrmHubEnabled(opts = {}) {
  try {
    const env = String(import.meta.env?.VITE_CRM_HUB_ENABLED || "").trim();
    if (env === "0") return false;
    if (env === "1") return true;
  } catch {
    // ignore
  }

  try {
    if (typeof localStorage !== "undefined") {
      const ls = localStorage.getItem("crm_hub_enabled");
      if (ls === "0") return false;
      if (ls === "1") return true;
    }
  } catch {
    // ignore
  }

  // DEV package preview: treat as agent of that tier (skip admin bypass).
  if (isAdminUser() && !opts.treatAsAgent) return true;

  if (CRM_HUB_ADMIN_ONLY) return false;

  if (CRM_HUB_PHASE_INCLUDES_BASIC) return true;

  const tier = resolveAgentPackageTier(opts.effectivePackageCode);
  return tier === "PRO" || tier === "AGENCY";
}
